import {SET_CURRENT_USER, SET_INVITED_USER} from "../actions/actionTypes";
import {objectIsEmpty} from "../../utils/utils";

const initialState = {
  isAuthenticated: false,
  user: {},
  invitedUser: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: objectIsEmpty(action.payload)
      };
    case SET_INVITED_USER:
      return {
        ...state,
        invitedUser: action.payload
      };
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/auth.js